import { Progress } from 'modules/types'
import { Dict } from 'types/generics'
import { AddError, EntityMetadata, FetchError, RemoveError, UpdateError } from 'modules/domain/types'
import { SeedPedigree } from 'modules/domain/seedTracker/types'

export enum SeedOrderStatus {
  Pending = 'Pending',
  Approved = 'Approved',
  InTransit = 'In Transit',
  Completed = 'Completed',
  Cancelled = 'Cancelled',
}

export enum DestinationType {
  Grower = 'Seed Grower',
  Farmer = 'Farmer',
  Other = 'Other',
}

export type SeedOrderCompanySnapshot = {
  id: string
  official_name: string
}

export type SeedOrderFarmerSnapshot = {
  id: string
  first_name?: string | null
  last_name?: string | null
  phone_number?: string | null
  email?: string | null
  farm_name?: string | null
  regions?: { title: string }[] | null
}

export type SeedOrderApiRecord = {
  id: string
  product_card_id: string
  origin_company_id: string
  destination_company_id: string
  destination_type?: DestinationType | null
  destination_farmer_id?: string | null
  destination_other_details?: string | null
  order_status: string
  sales_order_number?: string | null
  purchase_order_number?: string | null
  sales_invoice_number?: string | null
  discounted: boolean
  current_pedigree: SeedPedigree
  sold_as_pedigree: SeedPedigree
  quantity_mt: string
  origin_current_mt?: string | null
  origin_requested_mt?: string | null
  origin_after_sale_mt?: string | null
  destination_current_mt?: string | null
  destination_requested_mt?: string | null
  destination_after_sale_mt?: string | null
  origin_region?: string | null
  origin_contact_name?: string | null
  origin_contact_number?: string | null
  origin_contact_email?: string | null
  destination_region?: string | null
  destination_contact_name?: string | null
  destination_contact_number?: string | null
  destination_contact_email?: string | null
  origin_company?: SeedOrderCompanySnapshot | null
  destination_company?: SeedOrderCompanySnapshot | null
  destination_farmer?: SeedOrderFarmerSnapshot | null
  destination_farmer_contact_number?: string | null
  destination_farmer_contact_email?: string | null
  created_at?: string
  updated_at?: string
}

export type SeedOrdersListRequestFilter = {
  search?: string
  product_card_id?: string
  origin_company_id?: string
  destination_company_id?: string
  order_status?: string
  current_pedigree?: string
}

export type SeedOrdersListRequestSorting = {
  sort_field?: string
  sort_reversed?: boolean
}

export type SeedOrdersState = {
  items: Dict<SeedOrderApiRecord>
  meta: Dict<EntityMetadata<SeedOrderApiRecord>>
  ids: string[]
  listFetchProgress: Progress
  listFetchError: FetchError | null
  listFetchNextProgress: Progress
  listFetchNextError: FetchError | null
  itemFetchProgress: Progress
  itemFetchError: FetchError | null
  addProgress: Progress
  addError: AddError | null
  updateProgress: Progress
  updateError: UpdateError | null
  removeProgress: Progress
  removeError: RemoveError | null

  filter: SeedOrdersListRequestFilter
  sorting: SeedOrdersListRequestSorting
  page: number
  total: number
  pageSize: number
}
